import { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import LocationContext from "@context/location/locationContext";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import HeaderBackButton from "@src/components/shared-ui-components/HeaderBackButton";
import { message } from "@src/constants";

import Check from "./Check";
import { getMappedSingleCheckData, getSingleCheckDisplay } from "./helper";
import { CheckCardWrapper } from "./style";

const SingleCheckDisplay: FC = () => {
  const { propertyShortName, checkNumber, notificationId } = useParams();
  const [singleCheckData, setSingleCheckData] = useState<JSX.Element[][]>([]);
  const [loading, setLoading] = useState(true);

  const [{ locationState }] = useContext(LocationContext);

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const { date } = locationState;

  const getData = async () => {
    const res = await getSingleCheckDisplay(
      propertyShortName ?? "",
      checkNumber ?? "",
      date ?? "",
      notificationId ?? ""
    );
    if (!res.error) {
      const mappedSingleCheckData = getMappedSingleCheckData(res?.data);
      setSingleCheckData(mappedSingleCheckData);
    } else {
      showErrorToastSetState({
        errorMessage: res?.error || "",
        errorTitle: message.ERROR_MESSAGE_DASHBOARD,
        open: true,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [propertyShortName, checkNumber, notificationId, date]);

  return (
    <>
      <HeaderBackButton title="Check Details" />
      <CheckCardWrapper>
        <Check singleCheckData={singleCheckData} loading={loading} />
      </CheckCardWrapper>
    </>
  );
};

export default SingleCheckDisplay;
